export default "__VITE_ASSET__DCf$bhfi__"